import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as notificationAPI from "../../api/notification";

const initialState = {
  data: null,
  loading: false,
  activeId: null,
  perPage: 10,
  page: 1,
  offset: 0,
};

const getAllStaffNotification = createAsyncThunk(
  "notification/get",
  async (params) => {
    try {
      const res = await notificationAPI.getAllStaffNotification(params);
      return res.data.body;
    } catch (error) {
      //console.log(error);
    }
  }
);

const addStaffNotification = createAsyncThunk(
  "notification/add",
  async (params) => {
    try {
      const payoad = {
        idDepartment: params.idDepartment,
        idFaculties: params.idFaculties,
        notification: params.notification,
        departmentName: "",
        institutionId: params.institutionId,
      };
      const res = await notificationAPI.addStaffNotification(payoad);
      return res.data.body;
    } catch (error) {
      //console.log(error);
    }
  }
);

const readStaffNotification = createAsyncThunk(
  "notification/read",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const payload = {
        id: params,
      };
      dispatch(setNotificationID(params));
      const res = await notificationAPI.readStaffNotification(payload);
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteStaffNotification = createAsyncThunk(
  "notification/delete",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setNotificationID(params.notificationGroupId));
      const res = await notificationAPI.deleteStaffNotification(params);
      if (res.data.statusCodeValue >= 400) {
        rejectWithValue(res.data.body);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const getStaffNotification = createAsyncThunk(
  "notification/getStaffNotification",
  async (params, { rejectWithValue }) => {
    try {
      const res = await notificationAPI.getStaffNotification(params);
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationID: (state, action) => {
      state.activeId = action.payload;
    },
    resetState: () => {
      return initialState;
    },
    resetActiveId: (state) => {
      state.activeId = initialState.activeId;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: {
    [getAllStaffNotification.pending]: (state) => {
      state.loading = true;
    },
    [getAllStaffNotification.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [getAllStaffNotification.rejected]: (state) => {
      state.loading = false;
    },

    [addStaffNotification.pending]: (state) => {
      state.loading = true;
    },
    [addStaffNotification.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action?.payload?.facultyNotificationAdded);
    },
    [addStaffNotification.rejected]: (state, action) => {
      state.loading = false;
      toast.success(action.payload.body);
    },

    [readStaffNotification.pending]: (state, action) => {
      //console.log("readStaffNotification", action.payload);
      state.loading = true;
      state.activeId = action.payload;
    },
    [readStaffNotification.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [readStaffNotification.rejected]: (state) => {
      state.loading = false;
    },

    [deleteStaffNotification.pending]: (state) => {
      state.loading = true;
    },
    [deleteStaffNotification.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteStaffNotification.rejected]: (state) => {
      state.loading = false;
    },

    [getStaffNotification.pending]: (state) => {
      state.loading = true;
    },
    [getStaffNotification.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [getStaffNotification.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const { resetState, setNotificationID, resetActiveId, setPerPage,
  setOffset,
  setPage, } =
  notificationSlice.actions;

export default notificationSlice.reducer;

export {
  resetState,
  setNotificationID,
  getAllStaffNotification,
  addStaffNotification,
  readStaffNotification,
  deleteStaffNotification,
  getStaffNotification,
  resetActiveId,
  setPerPage,
  setOffset,
  setPage,
};
